import { IRootState } from '../reducers/rootReducer'

export const getContextReducer = (state: IRootState): any => {
  return state?.context
}
